import * as actionTypes from '../constants/action-types';

export const getAnswerGroupDataAction = (data) => ({
  type: actionTypes.GET_ANSWER_GROUP_DATA,
  answerGroupId: data,
});
